export class InternalServerError extends Error {
  constructor(private readonly originalError?: any) {
    super('Internal serve error');
  }
}
